import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeesIddProgressModel } from 'src/app/models/dashboard/employees-idd-progress.model';
import { DashboardWidgetsDataService } from 'src/app/services/dashboard-widget-data.service';

@Component({
    selector: 'app-qualification-status-widget',
    templateUrl: './qualification-status-widget.component.html',
    styleUrl: './qualification-status-widget.component.scss',
    standalone: false
})
export class QualificationStatusWidgetComponent {
  managerChartData: Array<{ label: string; value: number; persons: string[] }> =
  [
    {
      label: '0-33%',
      value: 0,
      persons: [],
    },
    {
      label: '34-66%',
      value: 0,
      persons: [],
    },
    {
      label: '67-99%',
      value: 0,
      persons: [],
    },
    {
      label: '100%',
      value: 0,
      persons: [],
    },
  ];

  constructor(    
    private router: Router,
    private dashboardWidgetsDataService: DashboardWidgetsDataService
  ) {
    this.customizeChartLabelText = this.customizeChartLabelText.bind(this);
  }

  ngOnInit() {
    this.dashboardWidgetsDataService.getEmployeesProgress().subscribe(data => {
      if (data) {
        this.managerChartData[0].value = 0;
        this.managerChartData[1].value = 0;
        this.managerChartData[2].value = 0;
        this.managerChartData[3].value = 0;

        this.managerChartData[0].persons = [];
        this.managerChartData[1].persons = [];
        this.managerChartData[2].persons = [];
        this.managerChartData[3].persons = [];

        data.employeeIddProgresses.forEach((progress) => {
          const personPercentage =
            (progress.employeesIddTimeMinutesReached * 100) /
            data.tenantIddTimeMinutesTarget;

          if (personPercentage >= 0 && personPercentage < 34) {
            this.managerChartData[0].value++;
            this.managerChartData[0].persons.push(progress.personId);
          } else if (personPercentage >= 34 && personPercentage < 67) {
            this.managerChartData[1].value++;
            this.managerChartData[1].persons.push(progress.personId);
          } else if (personPercentage >= 67 && personPercentage < 100) {
            this.managerChartData[2].value++;
            this.managerChartData[2].persons.push(progress.personId);
          } else if (personPercentage >= 100) {
            this.managerChartData[3].value++;
            this.managerChartData[3].persons.push(progress.personId);
          }
        });

        this.managerChartData = [...this.managerChartData];
      }
    });
  }

  customizeChartLabelText(arg: any) {
    let value;

    if (arg.pointName == '0-33%') {
      value = this.managerChartData[0].value;
    } else if (arg.pointName == '34-66%') {
      value = this.managerChartData[1].value;
    } else if (arg.pointName == '67-99%') {
      value = this.managerChartData[2].value;
    } else if (arg.pointName == '100%') {
      value = this.managerChartData[3].value;
    }

    return `${arg.pointName} (${value})`;
  }

  customizeManagerChartPoint(pointInfo: any) {
    if (pointInfo.argument === '0-33%') {
      return { color: '#f53d3dcc' };
    } else if (pointInfo.argument === '34-66%') {
      return { color: '#e8b34acc' };
    } else if (pointInfo.argument === '67-99%') {
      return { color: '#aed959cc' };
    } else {
      return { color: '#66cc66cc' };
    }
  }

  onManagerPointClick(event: any) {
    const persons = event.target.data.persons;

    this.router.navigate(['/employee'], {
      queryParams: { persons: JSON.stringify(persons) },
    });
  }
}
